import { Component, ViewChild } from '@angular/core';
import { FeathersAppService } from '@fire/feathers';
// import {MdSnackBar} from '@angular/material';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { fireLogger } from '../../../core/utils/fire-logger';
import { AuthService } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material';
import { UserService } from '../../../core/services/user.service';
// import { AuthService } from '../_services/auth.service';



@Component({
  templateUrl: './login-page.html',
  styleUrls: ['./login-page.scss'],
})

export class LoginPageComponent {


  @ViewChild('passwordInput') passwordInput;
  @ViewChild('emailInput') emailInput;
  // hideEmailField:boolean = false;
  email = '';
  password = '';
  // errMessage$;


  constructor(
    private router:Router,
    private authService:AuthService,
    private snackBar:MatSnackBar,
    private userService:UserService,
    // private route:ActivatedRoute,
  ) {
  }

  //
  //
  // ngOnInit() {
  //   this.attemptAutoLogin();
  // }

  ngAfterViewInit() {
    this.resetFields();
    this.emailInput.nativeElement.focus();



  //   this.route.queryParamMap.map(queryParams => {
  //     console.log('queryParams', queryParams);
  //   });
  //
  //
  //   this.errMessage$ = this.route.paramMap.map((paramMap:ParamMap) => {
  //
  //
  //     this.email = paramMap.get('email');
  //
  //     if (this.email) {
  //       this.hideEmailField = true;
  //     }
  //
  //
  //
  //
  //     const err = paramMap.get('err');
  //     switch (err) {
  //       case 'not-admin':
  //         return 'This login does not have Administration privileges.';
  //       default:
  //         return '';
  //     }
  //   });

  }



  attemptLogin() {
    const creds = {
      email: this.email,
      password: this.password,
    };

    fireLogger.log('creds', creds);

    // FIX --
    this.authService.authenticateLocal(creds)
      .then(() => this.onSuccessfulLogin())
      .catch(err => {

        fireLogger.log('Local auth error', err);

        const errorParams = (err.code === 401) ? { message: 'Incorrect login', duration: 3000 } :
          (err.message.includes('timed out')) ? { message: 'Could not log in (bad connection)', duration: 7000} :
            (err.message) ? { message: 'Could not log in (' + err.message + ')', duration: 7000 } :
              { message: 'Could not log in', duration: 5000 };

        this.snackBar.open(errorParams.message, 'Close', { duration: errorParams.duration });

        // make sure we're logged out
        this.authService.logout(false);
      });

  }


  // FIX --
  // private attemptAutoLogin() {
  //   this.feathers.authenticateJwt()
  //     .then(() => this.onSuccessfulLogin())
  //     .catch(() => {
  //       fireLogger.log('Could not auto-authenticate with JWT');
  //     });
  // }


  private onSuccessfulLogin() {
    this.resetFields();

    console.log('this.authService.user', this.authService.user);

    if (['dretter@retterlaw.com', 'test@firecoding.com'].includes(this.authService.user.email)) {
      this.router.navigate(['/admin/main-menu']);
    } else {
      this.router.navigate(['/admin']);
    }

  }


  resetFields() {
    this.email = '';
    this.password = '';
  }


  addUser() {

    console.log('add this ADMIN user:');

    const creds = {
      email: this.email,
      password: this.password,
    };

    fireLogger.log('creds', creds);


    this.userService.create({
      email: this.email,
      password: this.password,
      isAdmin: true,
    })
      .then(result => fireLogger.log('result', result))
      .catch(err => fireLogger.error('err', err));
  }

  navToAdminArea() {
    this.router.navigate(['/admin/dashboard']);
  }

  onInputKeyUp($event, inputField:string) {

    if ($event.key === 'Enter') {
      if (inputField === 'email') {
        this.passwordInput.nativeElement.focus();
      } else {
        this.attemptLogin();
      }
    }

  }

  populateFields() {
    this.email = 'test@firecoding.com';
    this.password = 'zzzzz1';
  }
}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/login-page/login-page.ts